import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="landing-page__footer">
      <div className="landing-page__footer-container">
        <div className="landing-page__footer-content">
          <div className="landing-page__footer-brand">
            <h3 className="landing-page__footer-logo">SmileWEB</h3>
            <p className="landing-page__footer-tagline">
              Sistema Integral de Gestión Médica
            </p>
          </div>
          <div className="landing-page__footer-links">
            <div className="landing-page__footer-section">
              <h4>Producto</h4>
              <ul>
                <li><a href="#features">Características</a></li>
                <li><a href="#contact">Contacto</a></li>
              </ul>
            </div>
            <div className="landing-page__footer-section">
              <h4>Legal</h4>
              <ul>
                <li><a href="#privacy">Política de Privacidad</a></li>
                <li><a href="#terms">Términos de Servicio</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="landing-page__footer-bottom">
          <p className="landing-page__footer-copyright">
            © {currentYear} SmileWEB. Todos los derechos reservados.
          </p>
          <p className="landing-page__footer-version">
            Versión 3.0
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
